var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIconWithPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14L18 4V9.3C17.6833 9.16667 17.3542 9.07917 17.0125 9.0375C16.6708 8.99583 16.3333 9 16 9.05V4.825L13.175 2H2V16H8V18H2ZM10 20V16.925L15.525 11.425C15.675 11.275 15.8417 11.1667 16.025 11.1C16.2083 11.0333 16.3917 11 16.575 11C16.775 11 16.9667 11.0375 17.15 11.1125C17.3333 11.1875 17.5 11.3 17.65 11.45L18.575 12.375C18.7083 12.525 18.8125 12.6917 18.8875 12.875C18.9625 13.0583 19 13.2417 19 13.425C19 13.6083 18.9667 13.7958 18.9 13.9875C18.8333 14.1792 18.725 14.35 18.575 14.5L13.075 20H10ZM11.5 18.5H12.45L15.475 15.45L15.025 14.975L14.55 14.525L11.5 17.55V18.5ZM15.025 14.975L14.55 14.525L15.475 15.45L15.025 14.975ZM3 7H12V3H3V7ZM9 15H9.1L12 12.125V12C12 11.1667 11.7083 10.4583 11.125 9.875C10.5417 9.29167 9.83333 9 9 9C8.16667 9 7.45833 9.29167 6.875 9.875C6.29167 10.4583 6 11.1667 6 12C6 12.8333 6.29167 13.5417 6.875 14.125C7.45833 14.7083 8.16667 15 9 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIconWithPencil);
export default __webpack_public_path__ + "static/media/saveIconWithPencil.e8405e36c2883711d5d5a7317e01236f.svg";
export { ForwardRef as ReactComponent };